module.exports = __webpack_public_path__ + "img/menu_gomb_dpc.060bd594.png";